import { BasicCustomerFragment, Maybe } from 'drycut-graphql';
import { Navigation } from 'navigation';
import { useNavigate } from 'react-router-dom';
import { ActionButtons, Button, Heading, Para, Stack } from 'ui-components';

type Props = {
  customer?: Maybe<BasicCustomerFragment>;
};

export default function ReviewConfirmation({ customer }: Props): JSX.Element {
  const navigate = useNavigate();

  if (!customer) {
    navigate('/not-found');
  }

  const customerPreferencesUrl = `${Navigation.BOOKING_URL}/preferences/${customer?.code}`;

  return (
    <Stack gap={10} className="h-full">
      <Stack gap={7} className="flex-grow items-center font-aribau text-center text-pretty">
        <Heading variant="h2">Vielen Dank für dein Feedback!</Heading>

        <Para>Wir freuen uns Dich bald wieder bei uns begrüssen zu dürfen!</Para>

        <Para>
          Nimm Dir doch ein paar Sekunden Zeit um Deinen bevorzugten Cut abzuspeichern. Das spart
          Zeit bei Deinem nächsten Besuch!
        </Para>
      </Stack>

      <ActionButtons>
        <Button as="a" href={customerPreferencesUrl}>
          Mein Cut
        </Button>

        <Button as="a" href={Navigation.HOME_URL} fill="outlined" className="no-underline">
          Schliessen
        </Button>
      </ActionButtons>
    </Stack>
  );
}
